import { useState } from "react";
import { CloseOutlined, UserOutlined } from "@ant-design/icons";
import { Input } from "antd";
import { AppStrings } from "../../../../../utils/constants/AppStrings";
import "./stylesDisableStaffModal.css";

const { TextArea } = Input;

function DisableStaffModal({ isOpen, onConfirm, onCancel, staffName: _staffName }) {
  const [comment, setComment] = useState("");

  const handleConfirm = () => {
    if (comment.trim()) {
      onConfirm(null, comment);
      setComment("");
    }
  };

  const handleCancel = () => {
    setComment("");
    onCancel();
  };

  if (!isOpen) return null;

  const isConfirmDisabled = !comment.trim();

  return (
    <div className="disable-staff-modal-overlay" onClick={handleCancel}>
      <div className="disable-staff-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="disable-staff-modal-close" onClick={handleCancel}>
          <CloseOutlined />
        </button>
        <div className="disable-staff-modal-header">
          <UserOutlined className="disable-staff-modal-icon" />
          <h3 className="disable-staff-modal-title">{AppStrings.DISABLING_STAFF}</h3>
        </div>
        <div className="disable-staff-modal-body">
          <p className="disable-staff-modal-question">
            {AppStrings.ARE_YOU_SURE_YOU_WANT_TO_DISABLE_THIS_STAFF}
          </p>
          <div className="disable-staff-modal-form">
            <div className="disable-staff-modal-field">
              <label>{AppStrings.LEAVE_A_COMMENT}</label>
              <TextArea
                placeholder={AppStrings.ENTER_YOUR_COMMENT_HERE}
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                rows={4}
                maxLength={200}
                showCount
                className="disable-staff-modal-textarea"
              />
            </div>
          </div>
        </div>
        <div className="disable-staff-modal-footer">
          <button className="disable-staff-modal-button cancel" onClick={handleCancel}>
            {AppStrings.NO}
          </button>
          <button
            className={`disable-staff-modal-button confirm ${isConfirmDisabled ? "disabled" : ""}`}
            onClick={handleConfirm}
            disabled={isConfirmDisabled}
          >
            {AppStrings.YES_DISABLE}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DisableStaffModal;

